import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { inject } from '@angular/core';


// if no accessToken, redirect to login
export const beforeLoginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.accessToken) {
    // authService.navigateLoggedInUser();
    router.navigate(['dashboard']);
    return false;
  }
  else return true;
};
